export default ((min, max, {
  message = `Please enter a value between ${min} and ${max}`
} = {}) => value => {
  const number = parseFloat(value);
  if (Number.isNaN(number) || number > max || number < min) return message;
  return null;
});